<template>
  <div class="mt-12">
    <h2 class="leading-none mb-6 text-3xl font-bold text-white">
      Change your password
    </h2>
    <div class="flex flex-wrap items-start mt-5 w-full">
      <Password
        ref="currentPassword"
        v-model="fields.current_password"
        class="w-full field mb-6"
        label="Current password"
        :error="errors.current_password"
        :hide-validation="true"
        is-dark-floating-label
        @onFocus="onFocus('current_password', 'current password')"
        @onBlur="onBlur('current_password', 'current password')"
      />
      <Password
        ref="password"
        v-model="fields.password"
        class="w-full field mb-6"
        label="New password"
        :error="errors.password"
        is-dark-floating-label
        @onFocus="onFocus('password', 'new password')"
        @onBlur="onBlur('password', 'new password')"
      />
      <Password
        ref="passwordConfirmation"
        v-model="fields.password_confirmation"
        class="w-full field mb-6"
        label="Confirm password"
        :error="errors.password_confirmation"
        is-dark-floating-label
        @onFocus="onFocus('password_confirmation', 'confirm password')"
        @onBlur="onBlur('password_confirmation', 'confirm password')"
      />
    </div>
  </div>
</template>

<script>
import Password from '@/components/Fields/password.vue';
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';

// eslint-disable-next-line max-len
const pswMessage = 'Password must be at least 6 characters long (up to 50 characters supported).';

export default {
  components: {
    Password,
  },
  props: {
    updatedSuccessfully: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: {
        current_password: '',
        password: '',
        password_confirmation: '',
      },
      lastValidationStatus: null,
      errors: {},
      fieldsPreviousValue: {},
    };
  },
  computed: {
    isPasswordValid() {
      const hasCurrentPassword = this.$refs.currentPassword.value.length > 0 ? this.$refs.currentPassword.validate : true;
      const hasPassword = this.$refs.password.value.length > 0 ? this.$refs.password.validate : true;
      const hasPasswordConfirmation = this.$refs.passwordConfirmation.value.length > 0 ? this.$refs.passwordConfirmation.validate : true;

      return hasCurrentPassword && hasPassword && hasPasswordConfirmation;
    },
  },
  watch: {
    fields: {
      handler() {
        this.emitValidateStatus();
      },
      deep: true,
    },
    'fields.current_password': function () {
      this.validateCurrentPassword();
    },
    'fields.password': function () {
      this.validatePassword();
    },
    'fields.password_confirmation': function () {
      this.validatePasswordConfirmation();
    },
    updatedSuccessfully() {
      this.fields.current_password = '';
      this.fields.password = '';
      this.fields.password_confirmation = '';
      setTimeout(() => {
        this.errors = {};
      }, 0);
    },
  },
  methods: {
    validateForm() {
      // reset errors
      this.errors = {};

      if (this.fields.current_password.length > 0 || this.fields.password.length > 0 || this.fields.password_confirmation.length > 0) {
        this.validateCurrentPassword();
        this.validatePassword();
        this.validatePasswordConfirmation();
      }
      this.emitValidateStatus();
    },
    validateCurrentPassword() {
      // only set error if we show password field
      this.$nextTick(() => {
        if (this.$refs.currentPassword.length < 1) {
          this.$set(
            this.errors,
            'current_password',
            'Please enter your current password.',
          );
        } else {
          this.$delete(this.errors, 'current_password');
        }
      });
    },
    validatePassword() {
      // only set error if we show password field
      this.$nextTick(() => {
        if (!this.$refs.password.validate) {
          this.$set(
            this.errors,
            'password',
            pswMessage,
          );
        } else {
          this.$delete(this.errors, 'password');
        }
      });
    },
    validatePasswordConfirmation() {
      // only set error if we show password field
      this.$nextTick(() => {
        if (!this.$refs.passwordConfirmation.validate) {
          this.$set(
            this.errors,
            'password_confirmation',
            pswMessage,
          );
        } else if (this.$refs.password.value !== this.$refs.passwordConfirmation.value) {
          this.$set(
            this.errors,
            'password_confirmation',
            'Password must be matched with confirmation password.',
          );
        } else {
          this.$delete(this.errors, 'password_confirmation');
        }
      });
    },
    emitValidateStatus() {
      this.$nextTick(() => {
        if (this.lastValidationStatus !== this.isPasswordValid) {
          this.lastValidationStatus = this.isPasswordValid;
          this.$emit('validatedPassword', this.isPasswordValid);
        }
      });
    },
    onFocus(key ,label) {
      eventTracker(analyticsEvents.inputInteracted, {
        input_placeholder: label,
        section_title: 'personal details',
        click_source: 'account page',
      });
      this.fieldsPreviousValue[key] = this.fields[key];
    },
    onBlur(key, label) {
      eventTracker(analyticsEvents.inputFilled, {
        input_placeholder: label,
        input_valid: this.errors[key] === undefined,
        error_text: this.errors[key],
        section_title: 'personal details',
        click_source: 'account page',
      });
    },
  },
};
</script>
